import styles from './ManageTeamProfile.module.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import Input from '../common/input/Input';
import { USER_ROLES } from './../../constants/UserRoles.const';
import { useEffect } from 'react';
import { getAllUsers } from '../../services/User.service';
import { setNotificationMessageSelector, setUsersSelector } from '../../hooks/store/setters';
import { useAppStore } from './../../hooks/store/useAppStore';
import { createTeam, updateTeam } from './../../services/Team.service';
import { v4 as uuid } from "uuid";
import { usersSelector } from './../../hooks/store/getters';
import { Table } from 'react-bootstrap';

const userRoles = Object.keys(USER_ROLES).filter(r => r !== 'ADMIN' ).map(role => ({
    label: role,
    value: role,
}))

const teamForm = {
    teamName: '',
    description: '',
    members: []
}

const convertToFormData = (team) => {
    if (!team) return teamForm;
    
    const members = team.members || []
    
    return { ...team, members }
}

const ManageTeamProfile = ({ show, onClose, user, viewMode=false }) => {
    
    const [formData, setFormData] = useState({});
    
    const setNotificationMessage = useAppStore(setNotificationMessageSelector);
    
    const users = useAppStore(usersSelector);
    const setUsers = useAppStore(setUsersSelector);
    
    const [filteredUsers, setFilteredUsers] = useState([])

    const [filters, setFilters] = useState({
        searchStr: "",
        role: ''
    })


    
    useEffect(() => {
        setFormData(convertToFormData(user))
    }, [user])
    
    useEffect(()=>{
        const getUsers = async () => {
            const users = await getAllUsers();
            setUsers(users);
        }
        getUsers();
    },[setUsers])
    
    useEffect(() => {
        console.log('filters changed ', filters);
        
        const searchStr = filters.searchStr.toLowerCase()
        
        const filteredUsers = users.filter(user => {
            if (
                user.userName.toLowerCase().includes(searchStr) ||
                user.email.toLowerCase().includes(searchStr)
            ) {
                return true
            }
            
            return false
        })
        
        setFilteredUsers(filteredUsers)
        
    }, [users, filters, setFilteredUsers])
    
    const handleMemberInputChange = user => {
        console.log('handleMemberInputChange', user)
        const exists = formData.members.find(m => m.uid === user.uid)
        
        if (exists) {
            setFormData({
               ...formData,
               members: [ ...formData.members.filter(m => m.uid !== user.uid) ] 
            }) 
        } else {
            setFormData({
               ...formData,
               members: [ ...formData.members, {...user, userRole: USER_ROLES.USER} ] 
            }) 
        }
    }
   
    const handleMemberRoleChange = (e, user) => {
        console.log('handleMemberRoleChange', user, e.target.value)
        const userIndex = formData.members.findIndex(m => m.uid === user.uid)
        
        if (userIndex > -1) {
            const members = formData.members;
            members[userIndex].userRole = e.target.value
            
            setFormData({
                ...formData,
                members
            })
        }
    }
    
    const updateFilterData = ({ target: { name, value } }) => {
        console.log('update filer', {name, value});
        
        setFilters({
            ...filters,
            [name]: value
        })
    }
    

    
    const handleInputChange = ({ target: { name, value } }) => {
        setFormData({
            ...formData,
            [name]: value
        })
    }
    
    const saveTeamProfile = async () => {
        console.log('save team profile', formData);
        try {
            const result = await updateTeam({...formData})
            onClose(result)
        } catch (error) {
            console.log('update failed ', error);
        }
    }
    
    const createTeamProfile = async () => {
        console.log('create new team', formData);
        try {
            const result = await createTeam({...formData, id: uuid()})
            console.log('created team', result)
            onClose({
                ...result,
                newlyAdded: true
            })
        } catch (error) {
            console.log('create team failed ', error);
            const msg = error && error.message ? error.message : 'Something went wrong'
            setNotificationMessage(msg)
        }
    }

    
    if (!show) return null;
    
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            contentClassName={styles.userProfileModal}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Team Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    viewMode ? (<>
                        <div className={styles.userInfo}>
                            <label>Name : </label>
                            <span> { user.teamName } </span>
                        </div>
                        <div className={styles.userInfo}>
                            <label>Description : </label>
                            <span> { user.description } </span>
                        </div>

                        <div className={styles.membersList}>
                            <Table striped borderless hover className={styles.userTable}>
                                <thead>
                                    <tr>  
                                        <th>Name</th>  
                                        <th>Email</th>  
                                        <th>Role</th>  
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    { user.members.sort((a, b) => b.userRole < a.userRole ? 1 :  b.userRole > a.userRole ? -1 : 0).map((u, index) => (  
                                        <tr data-index={index} key={index}>  
                                            <td>{u.userName}</td>  
                                            <td>{u.email}</td>  
                                            <td>{u.userRole}</td>
                                        </tr>  
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </>) : (<>
                        <div className={styles.userInfo}>
                            <Input
                                label="Team Name"
                                placeholder="team name"
                                name="teamName"
                                value={formData.teamName}
                                onChange={handleInputChange}
                            ></Input>
                        </div>
                        <div className={styles.userInfo}>
                            <Input
                                label="Description"
                                placeholder="description"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                            ></Input>
                        </div>
                                
                        <div className={styles.membersList}>
                            <label className={styles.memberLabel}>
                                Members: { formData?.members?.length || '0' } selected
                            </label>
                            <Input
                                variant="light"
                                placeholder="Search users"
                                name="searchStr"
                                value={filters.searchStr}
                                onChange={(e) => updateFilterData(e)}
                            />
                        </div>
                        
                        <div className={styles.membersList}>
                            <Table striped borderless hover className={styles.userTable}>
                                <thead>
                                    <tr>  
                                        <th>Name</th>  
                                        <th>Email</th>  
                                        <th>Role</th>  
                                        <th>Action</th>  
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    { filteredUsers.filter(u => u.userRole !== USER_ROLES.ADMIN).map((user, index) => (  
                                        <tr data-index={index} key={index}>  
                                            <td>{user.userName}</td>  
                                            <td>{user.email}</td>  
                                            <td>
                                                <Input
                                                    disabled={!formData?.members?.find(m => m.uid === user.uid)}
                                                    placeholder="role"
                                                    name="userRole"
                                                    type="select"
                                                    options={userRoles}
                                                    value={formData?.members?.find(m => m.uid === user.uid)?.userRole}
                                                    onChange={(e) => handleMemberRoleChange(e, user)}
                                                ></Input>
                                            </td>
                                            <td>
                                                <Input
                                                    type="checkbox"
                                                    name="description"
                                                    checked={!!formData?.members?.find(m => m.uid === user.uid)}
                                                    onChange={() => handleMemberInputChange(user)}
                                                ></Input>
                                            </td>
                                        </tr>  
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </>)
                }
            </Modal.Body>  
            
            <Modal.Footer>
                {
                    !viewMode && user && <Button variant="warning"
                        onClick={saveTeamProfile}
                    >Update Team</Button>
                }
                {
                    !viewMode && !user && <Button variant="warning"
                        onClick={createTeamProfile}
                    >Create Team</Button>
                }
                <Button variant="outline-secondary"
                    onClick={onClose}
                >Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ManageTeamProfile;